document.addEventListener('DOMContentLoaded', () => {

    const openBtn = document.querySelector(".open-menu");
    const menu = document.querySelector(".menu-am");
    const items = menu.querySelectorAll(".menu-item");
    const closeBtn = document.querySelector(".menu-close");

    let isOpen = false;

    const tl = gsap.timeline({ paused: true, defaults: { ease: "power3.out" } });

    gsap.set(items, { x: -12, opacity: 0 });

    tl
        .set(menu, { visibility: "visible" }, 0)
        .to(menu, { x: "0%", opacity: 1, duration: 0.45 }, 0)
        .to(items, {
            x: 0,
            opacity: 1,
            duration: 0.35,
            stagger: 0.05
        }, 0.12);

    function openMenu() {
        if (isOpen) return;
        isOpen = true;
        menu.setAttribute("aria-hidden", "false");
        tl.play(0);
    }

    function closeMenu() {
        if (!isOpen) return;
        isOpen = false;
        menu.setAttribute("aria-hidden", "true");
        tl.reverse();
    }

    function toggleMenu() {
        isOpen ? closeMenu() : openMenu();
    }

    openBtn?.addEventListener("click", toggleMenu);
    closeBtn?.addEventListener("click", closeMenu);

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeMenu();
    });

    tl.eventCallback("onReverseComplete", () => {
        gsap.set(menu, { visibility: "hidden" });
        gsap.set(items, { x: -12, opacity: 0 });
    });

});